/**
 * `/api/rocketchat` — the `rocketchat` module: each user's Rocket.Chat
 * username, so a notification rule on a Rocket.Chat channel can send that
 * person a direct message instead of posting to the webhook's room.
 *
 * **Set by an administrator only.** A username decides who reads a direct
 * message; a user able to set their own could point everybody's messages to
 * them at somebody else. Reading one needs `user.read`, changing one
 * `user.update` — core's permissions: a chat username is part of the account.
 * Everybody may read their own, at `/api/rocketchat/me`.
 */
/** Bounds the server enforces, exported so a form can show them first. */
export const ROCKETCHAT_LIMITS = {
    /** Longest username accepted. */
    username: 64,
};
/**
 * What a username may contain: Rocket.Chat's default rule, letters, digits,
 * `.`, `_` and `-`. **No `@` and no `#`** — the server adds the `@`, so a stored
 * value can never aim a direct message at a room.
 *
 * A string rather than a `RegExp`, so this package stays types and constants.
 */
export const ROCKETCHAT_USERNAME_PATTERN = '^[A-Za-z0-9._-]{1,64}$';
//# sourceMappingURL=rocketchat.js.map